import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";
import moment from "moment";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import {handleCheckboxChange, handleRadioChange } from "../../DownloadAndDelete/actions";
import { setA11yContent } from "../../NavigationHelper/actions";
import { media,isMobile } from "utils/style";
import RectangleLoader from "common-components/RectangleLoader";
import { replaceHashValues } from "utils/replaceHashValues";
import { checkNestedObject } from "utils/checkNestedObject";

import Button from "common-components/Buttons";
import { TitleLockup } from "@vds/type-lockups";
import { RadioButton } from "@vds/radio-buttons";
import { Body, Title } from "@vds/typography"
import { Checkbox } from "@vds/checkboxes";
import CommonHeader from "common-components/Header";
import CommonContainer from "common-components/Container";
// import { Radio, Checkbox } from "common-components/FormContent";

import "./AuthorizedAgentRequestDownload.css";

class AuthorizedAgentRequestDownload extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("Download categories", this.props.pageContent.sc_pagetitle);
    }
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.history.push(
      this.props.sensitivitySelection === "REGULAR"
        ? 
        "/privacy/secure/authorized-agent/download-amount"
        // "/privacy/secure/authorized-agent/file-format-selection"
        : "/privacy/secure/authorized-agent/download/affidavit-primer",
      {
        confirmAuth: true,
        fromAuthorizedAgent: true,
        customerHistory: this.props.location.state.customerHistory
      }
    );
  };

  isCheckboxSelected = () => {
    for (let item of this.props.downloadCategories) {
      if (item.checked) {
        return false;
      }
    }
    return true;
  };

  shouldRadioBeDisabled = ({ uniqueId }) => {
    const { noOfRegularDownloadRemaining, noOfAffidavitDownloadRemaining } = this.props;

    if (
      (uniqueId === "standard" && noOfRegularDownloadRemaining === 0) ||
      (uniqueId === "affidavit" && noOfAffidavitDownloadRemaining === 0)
    ) {
      return true;
    }
    return false;
  };

  selectDefaultCheckedRadio = ({ uniqueId }) => {
    const { sensitivitySelection } = this.props;

    if (
      (uniqueId === "standard" && sensitivitySelection === "REGULAR") ||
      (uniqueId === "affidavit" && sensitivitySelection === "AFFIDAVIT")
    ) {
      return true;
    }
    return false;
  };

  renderLimitReachedText = pageContent => {
    return pageContent.map(item => {
      const formattedDate = date => moment(date, "YYYY-MM-DD").format("MMM D, YYYY");

      if (this.props.noOfAffidavitDownloadRemaining === 0) {
        if (item.icon === "maximum_affidavit_reached") {
          return (
            <LimitReachedText key={item.icon}>
              {convertStringToElements(
                replaceHashValues(item.text, {
                  affidavitDate: formattedDate(this.props.nextRollOffDateAffidavitDownload)
                })
              )}
            </LimitReachedText>
          );
        }
      } else if (this.props.noOfRegularDownloadRemaining === 0) {
        if (item.icon === "maximum_regular_reached") {
          return (
            <LimitReachedText key={item.icon}>
              {convertStringToElements(
                replaceHashValues(item.text, {
                  regularDate: formattedDate(this.props.nextRollOffDateRegularDownload)
                })
              )}
            </LimitReachedText>
          );
        }
      }
      return null;
    });
  };

  render() {
    const { pageContent,agentSelectedCustomer:{serviceType}} = this.props; 
    var downloadCategoriesDetails = this.props.downloadCategories;

    if (!pageContent) {
      return <Redirect to="/privacy/secure/authorized-agent" />;
    }
    if (this.props.loading) {
      return <RectangleLoader id={"agentLoader"} />;
    }
    if ( serviceType === "autoapp" || serviceType === "ip") {
      downloadCategoriesDetails = this.props.downloadCategories.filter(
        (item) => item.category_id && item.category_id !== "collectedinferences" && item.category_id !== "addons"
      );
    }

    return (
      <Container>
        <div style={{maxWidth:"595px"}}>
          <div style={{  marginBottom: '32px'}}>
          {/* DPCMP - 3792, 3791 */}
          <TitleLockup 
              surface= 'light'
              textAlignment= 'left'
              viewport={isMobile ? "mobile": "desktop"}
              data={{
                 title:{
                  size:'titleXLarge',
                  bold: false,
                  children: convertStringToElements(pageContent.section_title)
                 }
              }}    
            />
          </div>
        {/* <Header>{convertStringToElements(pageContent.section_title)}</Header> */}
          <form onSubmit={this.handleSubmit}>
            <fieldset>
              <Title  size ='medium' bold={true} style={{marginBottom:"32px"}}>{convertStringToElements(pageContent.section_description)}</Title> 

              {downloadCategoriesDetails.map(item => (
                <CheckboxContainer key={item.category_id}>
                  <Checkbox 
	                  name="selectItem"
                    className="Select_Information_Checkbox"
                    value={item.category_id}
                    onChange={this.props.handleCheckboxChange}
	                  label={item.category_name}
                    ariaLabel={item.category_name}
	                  disabled={false}
	                  error={false}
	                  errorText="Please agree to the terms and conditions."
                    checked={item.checked || false}
                  >
                  {item.category_description}
                  </Checkbox>
                </CheckboxContainer>
              ))}
            </fieldset>
            <fieldset style={{ margin: "24px 0 48px 0" }}>
            <TitleLockup 
              surface= 'light'
              textAlignment= 'left'
              viewport={isMobile ? "mobile": "desktop"}
              data={{
                 title:{
                  size:'titleLarge',
                  bold: false,
                  children: convertStringToElements(pageContent.icontexts[0].headingText)
                 },
                 subtitle:{
                  size: 'bodyLarge',
                  primitive:'p',
                  children: <Div> 
                    <span>{convertStringToElements(pageContent.icontexts[0].text)}</span>
                    <div>{this.renderLimitReachedText(pageContent.icontexts)}</div>
                  </Div>
                  }
              }}    
            />
              {/* <Legend>{pageContent.icontexts[0].headingText}</Legend>
              <Div>
                <span>{convertStringToElements(pageContent.icontexts[0].text)}</span>
                <div>{this.renderLimitReachedText(pageContent.icontexts)}</div>
              </Div> */}
              {pageContent.genericList[0].list.map(item => (
                <div style={{marginLeft:"24px", marginBottom:"24px"}} key={item.jsonKey}>
                  <RadioButton
                    name="sensitivitySelection"
                    size="large"
                    value={item.uniqueId}
                    label={item.jsonKey}
                    ariaLabel={item.jsonKey + item.jsonValue}
                    children={item.jsonValue}
                    onChange={this.props.handleRadioChange}
                    disabled={this.shouldRadioBeDisabled(item)}
                    selected={this.selectDefaultCheckedRadio(item)}
                  />
                </div>
              ))}
            </fieldset>
            <Button
              type="submit"
              disabled={this.isCheckboxSelected()}
              background={pageContent.buttons[0].type}
            >
              {pageContent.buttons[0].text}
            </Button>
          </form>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = ({
  pageContent: { download_categories: pageContent },
  downloadInputInformation: { downloadCategories, sensitivitySelection },
  loadingAndErrorState: { loading, error },
  downloadAndDelete: {
    noOfRegularDownloadRemaining,
    noOfAffidavitDownloadRemaining,
    nextRollOffDateRegularDownload,
    nextRollOffDateAffidavitDownload
  },
  agentSelectedCustomer
}) => ({
  pageContent,
  downloadCategories,
  loading,
  sensitivitySelection,
  noOfRegularDownloadRemaining,
  noOfAffidavitDownloadRemaining,
  nextRollOffDateRegularDownload,
  nextRollOffDateAffidavitDownload,
  agentSelectedCustomer
});

AuthorizedAgentRequestDownload.propTypes = {
  pageContent: PropTypes.object,
  downloadCategories: PropTypes.array,
  sensitivitySelection: PropTypes.string,
  nextRollOffDateRegularDownload: PropTypes.string,
  nextRollOffDateAffidavitDownload: PropTypes.string,
  noOfAffidavitDownloadRemaining: PropTypes.number,
  noOfRegularDownloadRemaining: PropTypes.number,
  handleCheckboxChange: PropTypes.func,
  handleRadioChange: PropTypes.func,
  setA11yContent: PropTypes.func
};

export default connect(
  mapStateToProps,
  {
    handleCheckboxChange,
    handleRadioChange,
    setA11yContent
  }
)(AuthorizedAgentRequestDownload);




const Div = styled.div`
  max-width: 595px;
  padding-bottom: 32px;

  p {
    margin: 10px 0;
  }

  span,p,strong{
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  letter-spacing: 0.5px
  }

  
`;

const LimitReachedText = styled.div`
  p {
    color: #007eed;
    margin-bottom: 15px;
  }
`;

const Legend = styled.legend`
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
`;


const CheckboxContainer = styled.div`
  font-size: 14px;
  line-height: 16px;
  margin-top: 25px;
  margin-left: -30px;
`;

// const RadioDescription = styled.p`
//   font-size: 10px;
//   padding: 10px 0 23px 32px;
//   line-height: 10px;
//   max-width: 261px;
//   font-family: "NeueHaasGroteskText";
// `;

const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
    margin: 0;
    padding: 32px 16px ;
  `}
`;

const Header = styled(CommonHeader)`
  max-width: 598px;
  font-size: 48px;
  line-height: 48px;
  margin-bottom: 32px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-weight: 300;

${media.mobile`
  font-size: 32px;	
  line-height: 36px;
  font-weight: 300;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
`}
`;

const Span = styled.span`
 font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
 font-size: 16px;
 font-style: normal;
 font-weight: 700;
 line-height: 20px; 
 letter-spacing: 0.5px;
${media.mobile`
  
`}
`;

const P = styled.p`
 font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
 font-size: 16px;
 font-style: normal;
 font-weight: 400;
 line-height: 20px;
 letter-spacing: 0.5px;
 padding: 0 0 24px 30px; 
`;